export { default } from './InputAdornment';